import * as React from 'react';
import classNames from 'classnames';

export interface RowProps extends Pick<React.HTMLAttributes<HTMLDivElement>, 'className' | 'style'>{
    children?: React.ReactNode;
}

export const Row: React.FC<RowProps> = ({ children, className, ...props }) => (
    <div className={classNames('row', className)} {...props}>
        {children}
    </div>
);
